import {
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_SUCCESS,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_FAIL,
    GET_AZURE_CLOUD_RESOURCES,
    GET_AZURE_CLOUD_RESOURCES_FAIL,
    GET_AZURE_CLOUD_RESOURCES_SUCCESS,
    GET_AZURE_REFRESH_FAIL,
    GET_AZURE_REFRESH_SUCCESS,
    GET_AZURE_REFRESH,
    GET_AZURE_NOTIFICATION_CHANNELS,
    GET_AZURE_NOTIFICATION_CHANNELS_FAIL,
    GET_AZURE_NOTIFICATION_CHANNELS_SUCCESS,
    POST_AZURE_CREATE_RESOURCE_ALERTS,
    POST_AZURE_CREATE_RESOURCE_ALERTS_FAIL,
    POST_AZURE_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    POST_AZURE_RESOURCE_SERVICE_MAPPING,
    POST_AZURE_RESOURCE_SERVICE_MAPPING_FAIL,
    POST_AZURE_RESOURCE_SERVICE_MAPPING_SUCCESS,
    GET_ALL_ORG_AZURE_RESOURCE_TYPES,
    GET_ALL_ORG_AZURE_RESOURCE_TYPES_FAIL,
    GET_ALL_ORG_AZURE_RESOURCE_TYPES_SUCCESS,
    GET_USER_RESCAN_STATUS_AZURE_FAIL,
    GET_USER_RESCAN_STATUS_AZURE_SUCCESS,
    GET_USER_RESCAN_STATUS_AZURE,
} from './actionTypes'

const INIT_STATE = {
    azure_refresh: [],
    azure_all_resource_alerts: {},
    azure_all_resource_count: {},
    azure_cloudResources: [],
    notification_channels: [],
    alerts: [],
    orgAzureResourceTypes:[],
    is_azure_refreshing: false,
    azure_rescan_status: true,
};
const AzureResource = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_AZURE_REFRESH:
            return {
                ...state,
                is_azure_refreshing: true,
            }

        case GET_AZURE_REFRESH_SUCCESS:
            return {
                ...state,
                is_azure_refreshing: false,
                azure_refresh: action.payload,
            }

        case GET_AZURE_REFRESH_FAIL:
            return {
                ...state,
                is_azure_refreshing: false,
                error: action.payload,
            }

        case GET_AZURE_ALL_RESOURCE_ALERTS_PAGE:
            return {
                ...state,
                is_azure_refreshing: true,
            }

        case GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_SUCCESS:
            return {
                ...state,
                azure_all_resource_alerts: action.payload,
                is_azure_refreshing: false,
            }

        case GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_refreshing: false,
            }

        case GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT:
            return {
                ...state,
                error: action.payload,
            }

        case GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_SUCCESS:
            return {
                ...state,
                azure_all_resource_count: action.payload,
            }

        case GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_AZURE_CLOUD_RESOURCES:
            return {
                ...state,
                is_azure_refreshing: true,
            }

        case GET_AZURE_CLOUD_RESOURCES_SUCCESS:
            return {
                ...state,
                azure_cloudResources: action.payload,
                is_azure_refreshing: false,
            }

        case GET_AZURE_CLOUD_RESOURCES_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_refreshing: false,
            }
        

        case GET_AZURE_NOTIFICATION_CHANNELS:
            return {
                ...state,
                is_azure_refreshing: true
            }

        case GET_AZURE_NOTIFICATION_CHANNELS_SUCCESS:
            return {
                ...state,
                notification_channels: action.payload,
                is_azure_refreshing: false
            }

        case GET_AZURE_NOTIFICATION_CHANNELS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_refreshing: false,
            }

        case POST_AZURE_CREATE_RESOURCE_ALERTS:
            return {
                ...state,
                is_azure_refreshing: true
            }

        case POST_AZURE_CREATE_RESOURCE_ALERTS_SUCCESS:
            return {
                ...state,
                alerts: action.payload,
                is_azure_refreshing: false
            }

        case POST_AZURE_CREATE_RESOURCE_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_refreshing: false
            }

        case POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING:
            return {
                ...state,
                is_azure_refreshing: true,
            }

        case POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS:
            action.payload.map((item) => {
                state.azure_all_resource_alerts[item.id].opsgenie_team_id = item.opsgenie_team_id;
                state.azure_all_resource_alerts[item.id].environment = item.environment;
            });
            return {
                ...state,
                azure_all_resource_alerts: state.azure_all_resource_alerts,
                is_azure_refreshing: false,
            }

        case POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_refreshing: false,
            }

        case POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING:
            return {
                ...state,
                is_azure_refreshing: true,
            }

        case POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS:
            action.payload.map((item) => {
                state.azure_all_resource_alerts[item.id].pagerduty_service_id = item.pagerduty_service_id;
                state.azure_all_resource_alerts[item.id].environment = item.environment;
            });
            return {
                ...state,
                azure_all_resource_alerts: state.azure_all_resource_alerts,
                is_azure_refreshing: false,
            }

        case POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_refreshing: false,
            }
        case POST_AZURE_RESOURCE_SERVICE_MAPPING_SUCCESS:
            action.payload.map((item) => {
                state.azure_all_resource_alerts[item.id].application_service_id = item.application_service_id;
                state.azure_all_resource_alerts[item.id].environment = item.environment;
                state.azure_all_resource_alerts[item.id].deployment_stage = item.deployment_stage;
            });
            return {
                ...state,
                azure_all_resource_alerts: state.azure_all_resource_alerts,
                is_azure_refreshing: false,
            }

        case POST_AZURE_RESOURCE_SERVICE_MAPPING_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_refreshing: false,
            }

        case POST_AZURE_RESOURCE_SERVICE_MAPPING:
            return {
                ...state,
                is_azure_refreshing: true,
            }


        case GET_ALL_ORG_AZURE_RESOURCE_TYPES:
            return {
                ...state,
                is_azure_refreshing: true,
            }

        case GET_ALL_ORG_AZURE_RESOURCE_TYPES_SUCCESS:
            return {
                ...state,
                orgAzureResourceTypes: action.payload,
                is_azure_refreshing: false,
            }

        case GET_ALL_ORG_AZURE_RESOURCE_TYPES_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_refreshing: false
            }

        case GET_USER_RESCAN_STATUS_AZURE:
            return {
                ...state,
                error: action.payload,
            }

        case GET_USER_RESCAN_STATUS_AZURE_SUCCESS:
            return {
                ...state,
                azure_rescan_status: action.payload.scan_completed,
            }

        case GET_USER_RESCAN_STATUS_AZURE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state;
    }
}

export default AzureResource;
